// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'

const EditableContext = React.createContext(false)

type EditableProviderProps = {
  children: any
}

type EditableProviderState = {
  isEditable: boolean
}

export class EditableProvider extends React.PureComponent<EditableProviderProps, EditableProviderState> {
  state = {
    isEditable: false,
  }

  toggleEditable = () => {
    this.setState({ isEditable: !this.state.isEditable })
  }

  render() {
    const { isEditable } = this.state

    return (
      <EditableContext.Provider value={{ isEditable }}>
        {this.props.children({
          isEditable,
          toggleEditable: this.toggleEditable,
        })}
      </EditableContext.Provider>
    )
  }
}
export const EditableConsumer = EditableContext.Consumer
